import { render, staticRenderFns } from "./MobileOfferDefault.vue?vue&type=template&id=54856ce4&scoped=true"
import script from "./MobileOfferDefault.vue?vue&type=script&lang=js"
export * from "./MobileOfferDefault.vue?vue&type=script&lang=js"
import style0 from "./MobileOfferDefault.vue?vue&type=style&index=0&id=54856ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54856ce4",
  null
  
)

export default component.exports